import {
  CircularProgress, IconButton, useMediaQuery,
} from "@material-ui/core";
import { Delete, LinkedIn, RemoveRedEye } from "@material-ui/icons";
import { debounce } from "lodash";
import React from "react";
import { withRouter, Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import { Box } from "@material-ui/core";
import "../../Services/SocieteService";
import { useRef , useState } from "react";
import { displaySwipeableDrawerSummaryContact } from "../../../redux/SwipeableDrawer/actions/swipeableDrawerActions";
import { useDispatch } from "react-redux";
import { getUserData, getRowData } from "../../../utils/FunctionHelpers";
import DialogDeleteCustom from "../../../components/DialogDeleteCustom/DialogDeleteCustom";
import { deleteContact } from "../../Services/ContactService";
import { withSnackbar } from "../../../utils/SnackbarHOC";
import { handleOnViewColumnsChange, displayColumn } from "../../../utils/viewColumns";
import { handleChangeRowsPerPage, getRowsPerPage } from "../../../utils/DataTables.js";
import moment from "moment";

const ContactList = ({
  contactsData,
  handleSearchContacts,
  snackbarShowMessage,
  parameters
}) => {
  const dispatch = useDispatch()
  const isSmall = useMediaQuery((theme) => theme.breakpoints.between(0, 767));
  const isMediumMode = useMediaQuery((theme) => theme.breakpoints.between(767, 1023));
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [contactSelectedToDelete, setContactSelectedToDelete] = useState(null)
  const [loadToDelete, setLoadToDelete] = useState(false)
  const sortingRef = useRef(false);

  const debouncedSearch = debounce((searchText, tableState, parameters, handleSearchContacts) => {
    handleSearchContacts(1, {
      ...parameters,
      column: tableState.sortOrder.name,
      sort: tableState.sortOrder.direction,
      search: searchText
    }, tableState.rowsPerPage);
  }, 800);

  const handlePageChange = (pageIndex, tableState) => {
    handleSearchContacts(pageIndex + 1, {
      ...parameters,
      column: tableState.sortOrder?.name,
      sort: tableState.sortOrder?.direction,
      search: tableState.searchText || "",
    }, tableState.rowsPerPage);
  };

  const handleCloseDialog = () => {
    if (loadToDelete) {
      return;
    }
    setOpenDialogDelete(false);
  };

  const handleOpenDialog = (contact) => {
    setContactSelectedToDelete({ id: contact.id, fullName: contact.fullName.charAt(0).toUpperCase() + contact.fullName.slice(1) });
    setOpenDialogDelete(true);
  }

  const handleDeleteContact = async (uuid) => {
    try {
      setLoadToDelete(true);
      snackbarShowMessage("Patientez svp...", "warning", null);
      const { data } = await deleteContact(uuid)
      handleSearchContacts(contactsData.pageContact, parameters);
      snackbarShowMessage(data);
    } catch (error) {
      snackbarShowMessage("Erreur à la suppression du contact", "error", 4000);
    } finally {
      setLoadToDelete(false);
      setOpenDialogDelete(false);
    }
  };

  const dialogDeleteProps = {
    handleClose: handleCloseDialog,
    handleOpen: openDialogDelete,
    loading: loadToDelete,
    title: "Supprimer le contact"
  }

  const tableName = "contactColumnVisibility";

  const columns = [
    {
      name: "updatedAt",
      label: "DATE MAJ",
      options: {
        display: displayColumn("updatedAt", tableName),
        filter: true,
        sort: true,
        sortDirection: contactsData.sorting?.name === 'updatedAt' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
        customBodyRender: (value) => {
          return <>{value?.date ? moment(value.date).format("DD/MM/YYYY") : "-"}</>;
        },
      },
    },
    {
      name: "uuid",
      label: "N°CONTACT",
      options: {
        display: false,
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width: "100px",
            textAlign: "left",
          },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center", maxWidth: "100px" },
        }),
        customBodyRender: (value) => {
          return (
            <Box>
              {((value?.substring(0, 20)?.replace(/\D/g, ""))).substring(1, 7)}
            </Box>
          );
        },
      },
    },
    {
      name: "titre",
      label: "TITRE",
      options: {
        display: false,
        customBodyRender: (value) => {
            return (
            <Box
              data-toggle="tooltip"
              title={value}
              style={{ textAlign: "left" }}
            >
              {value}
            </Box>
          );
        },
      },
    },
    {
      name: "nom",
      label: "NOM",
      options: {
        display: displayColumn("nom", tableName),
        filter: true,
        sort: true,
        sortDirection: contactsData.sorting?.name === 'nom' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value, tableMeta) => {
            const row = getRowData(tableMeta, columns);
            return (
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              {!(isSmall || isMediumMode) && <IconButton
                onClick={() => dispatch(displaySwipeableDrawerSummaryContact({ show: true, idContact: row.uuid, idSociete: row.idSociete }))}
                data-toggle="tooltip"
                title="Voir resumé">
                <RemoveRedEye size={"15px"} /></IconButton>}
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textTransform: "capitalize",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                  marginLeft: "9%",
                }}
              >
                <Link
                  to={{
                    pathname: `/societe/${row.idSociete}/contacts/${row.uuid}/view`,
                  }}
                  className="d-print-none font-sm"
                  style={{ textDecoration: "none" }}
                >
                  {value}
                </Link>
              </Box>
            </Box>
          );
        },
      },
    },
    {
      name: "prenom",
      label: "PRENOM",
      options: {
        display: displayColumn("prenom", tableName),
        filter: true,
        sort: true,
        sortDirection: contactsData.sorting?.name === 'prenom' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value, tableMeta) => {
            const row = getRowData(tableMeta, columns);
            return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textTransform: "uppercase",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                }}
              >
                <Link
                  to={{
                    pathname: `/societe/${row.societeId}/contacts/${row.uuid}/view`,
                  }}
                  className="d-print-none font-sm"
                  style={{ textDecoration: "none" }}
                >
                  {value}
                </Link>
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "societeId",
      label: "N°SOCIETE",
      options: {
        display: false,
        customBodyRender: (value) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                  textAlign: "left",
                }}
              >
                {value}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "statut",
      label: "STATUT",
      options: {
        display: displayColumn("statut", tableName),
        filter: true,
        sort: true,
        sortDirection: contactsData.sorting?.name === 'statut' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                  textAlign: "left",
                }}
              >
                {value ?? "-"}
              </Box>
            </>
          );
        },
      }
    },
    {
      name: "fonction",
      label: "FONCTION",
      options: {
        display: displayColumn("fonction", tableName),
        sort: true,
        sortDirection: contactsData.sorting?.name === 'fonction' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                  textAlign: "left",
                  textTransform: "capitalize",
                }}
              >
                {value ?? "-"}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "societe",
      label: "SOCIETE",
      options: {
        display: displayColumn("societe", tableName),
        filter: true,
        sort: true,
        sortDirection: contactsData.sorting?.name === 'societe' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value, tableMeta) => {
            const row = getRowData(tableMeta, columns);
            return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textTransform: "uppercase",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                }}
              >
                <Link
                  to={{ pathname: `/societe/${row.societeId}/view` }}
                  className="d-print-none font-sm"
                  style={{ textDecoration: "none" }}
                >
                  {value ?? "-"}
                </Link>
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "missionsCount",
      label: "MISSIONS",
      options: {
        display: displayColumn("missionsCount", tableName),
        sort: true,
        sortDirection: contactsData.sorting?.name === 'missionsCount' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value, tableMeta) => {
            const row = getRowData(tableMeta, columns);
            return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                  textAlign: "center"
                }}
              >
                <Link
                  to={{
                    pathname: `/societe/${row.societeId}/contacts/${row.uuid}/view`,
                    state: { tabIndex: 3 },
                  }}
                  className="d-print-none font-sm"
                  style={{ textDecoration: "none" }}
                >
                  {value ?? "-"}
                </Link>
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "mobile",
      label: "MOBILE",
      options: {
        display: displayColumn("mobile", tableName),
        sort: true,
        sortDirection: contactsData.sorting?.name === 'mobile' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                }}
              >
                {value}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "telFix",
      label: "TEL PRO",
      options: {
        display: displayColumn("telFix", tableName),
        sort: true,
        sortDirection: contactsData.sorting?.name === 'telFix' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                }}
              >
                {value ?? "-"}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "email",
      label: "EMAIL PRO",
      options: {
        display: displayColumn("email", tableName),
        sort: true,
        sortDirection: contactsData.sorting?.name === 'email' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              >
                {value ?? "-"}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "linkedIn",
      label: "LINKEDIN",
      options: {
        display: displayColumn("linkedIn", tableName),
        sort: true,
        sortDirection: contactsData.sorting?.name === 'linkedIn' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "100px",
                }}
              >
                <a href={value} target="_blank" rel="noreferrer">
                  <LinkedIn />
                </a>
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "localisation",
      label: "LOCALISATION",
      options: {
        display: displayColumn("localisation", tableName),
        sort: true,
        sortDirection: contactsData.sorting?.name === 'localisation' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        customBodyRender: (value) => {
          return (
            <>
              <Box
                data-toggle="tooltip"
                title={value}
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              >
                {value ?? "-"}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "createdAt",
      label: "DATE CRÉATION",
      options: {
        display: displayColumn("createdAt", tableName),
        filter: true,
        sort: true,
        sortDirection: contactsData.sorting?.name === 'createdAt' ? contactsData.sorting?.direction?.toLowerCase() : undefined,
        setCellHeaderProps: () => ({ style: { whiteSpace: "nowrap" } }),
        customBodyRender: (value) => {
          const realDate = value?.date ?? null;
          return <> {realDate ? moment(realDate).format("DD/MM/yyyy") : "-"} </>;
        },
      },
    },
    {
      name: "",
      label: "ACTION",
      options: {
        filter: false,
        sort: false,
        display: getUserData()?.role.includes("ROLE_ADMIN"),
        setCellProps: () => ({
          style: {
            whiteSpace: "nowrap",
            textOverFlow: "ellipsis",
            overflow: "hidden",
            maxWidth: "100px",
            textTransform: "capitalize",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
            const row = getRowData(tableMeta, columns);
          return (
            <IconButton data-toggle="tooltip" title="Supprimer" aria-label="Supprimer" onClick={() => handleOpenDialog({ id: row.uuid, fullName: `${row.nom}  ${row.prenom}` })} style={{ color: "#EF6262" }}>
              <Delete />
            </IconButton>
          );
        },
      },
    }
  ];

  const options = {
    rowsPerPageOptions: [30, 50, 75, 100],
    page: contactsData.pageContact - 1,
    serverSide: true,
    jumpToPage: true,
    tableBodyMaxHeight: "none",
    count: contactsData.contactsCount,
    rowsPerPage: getRowsPerPage(tableName) ?? contactsData.limit,
    textLabels: {
      body: {
        noMatch: contactsData.isLoading ? (
          <CircularProgress />
        ) : (
          "Désolé, il n'y a aucun enregistrement dans la base de données pour le moment."
        ),
      },
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case "changeRowsPerPage":
          handleChangeRowsPerPage(tableName, tableState.rowsPerPage);
          handleSearchContacts(1, parameters, tableState.rowsPerPage);
          break;
        case "changePage":
          if (sortingRef.current) {
            sortingRef.current = false;
            break;
          }
          handlePageChange(tableState.page, tableState);
          break;
        case "sort":
          sortingRef.current = true;
          const { name: columnName, direction: sortDir } = tableState.sortOrder;
          handleSearchContacts(1, {
            ...parameters,
            column: columnName,
            sort: sortDir,
          });
          break;
        case "search":
          const searchText = tableState.searchText || "";
          debouncedSearch(searchText, tableState, parameters, handleSearchContacts);
          break;
        default:
      }
    },
    sortOrder: {
      name: contactsData.sorting?.name || contactsData.sorting?.column || '',
      direction: contactsData.sorting?.direction || 'asc'
    },
    onViewColumnsChange: (columnName, action) => {
      handleOnViewColumnsChange(columnName, action, tableName);
    },
    selectableRows: "multiple",
    draggableColumns: {
      enabled: false,
    },
    filter: false,
    filterType: "dropdown",
    responsive: "standard",
  };

  return (
    <>
        <div className="candidatTableWrapper" style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      <MUIDataTable data={contactsData.contacts} title="Contacts" columns={columns} options={options} />
      <DialogDeleteCustom {...dialogDeleteProps} handleDelete={() => handleDeleteContact(contactSelectedToDelete?.id)} label={`Voulez - vous vraiment supprimer le contact ${contactSelectedToDelete?.fullName} ?`} />
        </div>
    </>
  );
};

export default withRouter(withSnackbar(ContactList));
